<template>
  <div>
      <v-col cols="12" class="border">
        <v-row>
          <v-col cols="1">
            <router-link
              to="/product-type"
              style="text-decoration: none"
              title="Back"
            >
              <v-btn
                color="warning"
                fab
                small
                dark
                style="float: left; margin-left: 5px"
              >
                <v-icon class="fa fa-arrow-left"></v-icon>
              </v-btn> </router-link
            >&nbsp;
          </v-col>
          <v-col cols="2">
            <span>Product Type Name:</span>
          </v-col>
          <v-col cols="5">
            <input
              type="text"
              class="form-control"
              placeholder="Input Product Type Name..."
              v-model="productTypeName"
              v-on:keyup.enter="addOptions"
              @keyup="validation"
              style="background-color: yellow"
              v-if="productTypeName.length == 0"
            />
            <input
              type="text"
              class="form-control"
              placeholder="Input Product Type Name..."
              v-model="productTypeName"
              v-on:keyup.enter="addOptions"
              @keyup="validation"
              v-else
            />
          </v-col>
          <v-col cols="2">
            <button
              class="btn btn-primary btn-md"
              @click="addOptions"
              style="width: 100%"
              v-if="showAddOptionBtn"
            >
              Add Options</button
            >&nbsp;
          </v-col>
          <v-col cols="2">
            <button
              class="btn btn-success btn-md"
              @click="generateOptions"
              style="width: 100%"
              v-if="listOptions.length > 0 && listVariants.length == 0"
            >
              Generate Variants</button
            >&nbsp;
          </v-col>
        </v-row>

        <button
          class="btn btn-success btn-md"
          @click="saveData"
          v-if="
            listVariants.length > 0 &&
            showBtn == true &&
            roles.update_product_type
          "
        >
          Submit</button
        >&nbsp;
        <!-- <button class="btn btn-primary btn-lg" @click="check">Check</button>&nbsp; -->
        <v-col cols="12" v-if="error">
          <v-alert type="error">
            {{ error }}
          </v-alert>
        </v-col>

        <v-tabs
          v-model="tab"
          background-color="primary"
          dark
          style="margin-top: 5px"
        >
          <v-tab> Upload Photo Description </v-tab>
          <v-tab> Choose Options Description </v-tab>
          <v-tab> Crawl Description </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card>
              <template>
                <ckeditor
                  v-model="upload_photo_description"
                  :editor="editor"
                  :config="editorConfig"
                ></ckeditor>
              </template>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card>
              <template>
                <ckeditor
                  v-model="choose_options_description"
                  :editor="editor"
                  :config="editorConfig"
                ></ckeditor>
              </template>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card>
              <template>
                <ckeditor
                  v-model="crawl_description"
                  :editor="editor"
                  :config="editorConfig"
                ></ckeditor>
              </template>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <v-col cols="12">
          <v-row>
            <v-col
              cols="3"
              v-for="(i, index) in listOptions"
              :key="i.id"
              class="border"
            >
              <span>Option Name</span>&nbsp;<a
                href="#"
                @click="removeOptions(index)"
                style="color: red"
                v-if="listVariants.length == 0"
                ><i class="fa fa-trash"></i
              ></a>
              <input
                type="text"
                class="form-control"
                v-model="i.optionName"
                v-on:keyup.enter="addOptions"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" v-if="headers.length > 0">
          <table width="100%" class="table table-striped">
            <thead class="thead-light">
              <tr style="font-size: 13px">
                <th v-for="i in headers" :key="i">
                  {{ i }}
                </th>
                <th>Price</th>
                <th>Gram</th>
                <th>Shopify SKU</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(i, index) in listVariants" :key="i.variant_id">
                <td v-for="j in i.options" :key="j.name">
                  <input type="text" class="form-control" v-model="j.value" />
                </td>
                <td style="width: 30%">
                  <v-row>
                    <v-col cols="4"
                      ><v-text-field
                        dense
                        outlined
                        background-color="white"
                        v-model="i.crawl_price"
                        label="Crawl"
                        hide-details="auto"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="4"
                      ><v-text-field
                        dense
                        outlined
                        background-color="white"
                        v-model="i.crawl_compare_price"
                        label="Crawl Compare"
                        hide-details="auto"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="4"
                      ><v-text-field
                        dense
                        outlined
                        background-color="white"
                        v-model="i.amz_crawl_price"
                        label="Amz Crawl"
                        hide-details="auto"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="4"
                      ><v-text-field
                        dense
                        outlined
                        background-color="white"
                        v-model="i.upload_photo_price"
                        label="Upload Photo"
                        hide-details="auto"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="4"
                      ><v-text-field
                        dense
                        outlined
                        background-color="white"
                        v-model="i.upload_photo_compare_price"
                        label="Upload Photo Compare"
                        hide-details="auto"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="4"
                      ><v-text-field
                        dense
                        outlined
                        background-color="white"
                        v-model="i.amz_upload_photo_price"
                        label="Amz Upload Photo"
                        hide-details="auto"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="4"
                      ><v-text-field
                        dense
                        outlined
                        background-color="white"
                        v-model="i.choose_options_price"
                        label="Choose Options"
                        hide-details="auto"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="4"
                      ><v-text-field
                        dense
                        outlined
                        background-color="white"
                        v-model="i.choose_options_compare_price"
                        label="Choose Options Compare"
                        hide-details="auto"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="4"
                      ><v-text-field
                        dense
                        outlined
                        background-color="white"
                        v-model="i.amz_choose_options_price"
                        label="Amz Choose Options"
                        hide-details="auto"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                </td>
                <td>
                  <v-text-field
                    dense
                    outlined
                    background-color="white"
                    v-model="i.gram"
                  ></v-text-field>
                </td>
                <td>
                  <v-combobox
                    multiple
                    v-model="i.shopify_store_skus"
                    append-icon
                    chips
                    deletable-chips
                    class="tag-input"
                    outlined
                    background-color="white"
                    :search-input.sync="search"
                  >
                  </v-combobox>
                </td>
                <td>
                  <button
                    class="btn btn-sm btn-primary"
                    @click="duplicateVariants(index)"
                    title="Duplicate"
                  >
                    <i class="fa fa-copy"></i></button
                  >&nbsp;
                  <button
                    class="btn btn-sm btn-danger"
                    @click="removeVariants(index)"
                    title="Delete"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <button
                  class="btn btn-info btn-sm"
                  style="text-align: right"
                  @click="addVariants"
                >
                  Add Variant
                </button>
              </tr>
            </tfoot>
          </table>
        </v-col>
      </v-col>

  </div>
</template>

<script>
//import axios from "axios";
import Amplify from "aws-amplify";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "Add-Product-Type",
  data: () => ({
    tab: null,
    AuthStr: "",
    listOptions: [],
    count: 0,
    headers: [],
    listVariants: [],
    productTypeName: "",
    countVariants: 0,
    error: "",
    showBtn: null,
    search: "",
    showAddOptionBtn: true,

    upload_photo_description: "",
    choose_options_description: "",
    crawl_description: "",

    editor: ClassicEditor,
    editorConfig: {
      //extraPlugins: "colorbutton",
    },
    roles: [],
  }),
  methods: {
    addOptions() {
      // var name = ""
      this.count += 1;
      var name = {
        id: this.count,
        optionName: "",
      };
      this.listOptions.push(name);
    },

    removeOptions(index) {
      this.listOptions.splice(index, 1);
      this.headers = [];
    },

    check() {
      console.log("listOptions: ", this.listOptions);
      console.log("listVariants: ", this.listVariants);
    },

    generateOptions() {
      console.log(this.listOptions);
      this.headers = [];
      this.error = "";
      for (const i of this.listOptions) {
        if (i.optionName != "") {
          this.headers.push(i.optionName);
        } else {
          this.error = "Option Name cannot be empty";
          this.headers = [];
          break;
        }
      }
    },

    addVariants() {
      this.showAddOptionBtn = false;
      this.count += 1;
      var item = {
        _id: this.count,
        options: [],
        crawl_price: 0,
        crawl_compare_price: 0,
        amz_crawl_price: 0,
        upload_photo_price: 0,
        upload_photo_compare_price: 0,
        amz_upload_photo_price: 0,
        choose_options_price: 0,
        choose_options_compare_price: 0,
        amz_choose_options_price: 0,
        shopify_store_skus: [],
        gram: "",
      };

      for (const i of this.listOptions) {
        var temp = {
          name: i.optionName,
          value: "",
        };
        item.options.push(temp);
      }

      this.listVariants.push(item);
    },

    duplicateVariants(index) {
      //var temp = this.listVariants[index]
      console.log("options: ", this.listVariants[index].options);
      this.count += 1;
      var temp = {
        _id: this.count,
        options: [],
        crawl_price: this.listVariants[index].crawl_price,
        crawl_compare_price: this.listVariants[index].crawl_compare_price,
        amz_crawl_price: this.listVariants[index].amz_crawl_price,
        upload_photo_price: this.listVariants[index].upload_photo_price,
        upload_photo_compare_price:
          this.listVariants[index].upload_photo_compare_price,
        amz_upload_photo_price: this.listVariants[index].amz_upload_photo_price,
        choose_options_price: this.listVariants[index].choose_options_price,
        choose_options_compare_price:
          this.listVariants[index].choose_options_compare_price,
        amz_choose_options_price:
          this.listVariants[index].amz_choose_options_price,
        shopify_store_skus: this.listVariants[index].shopify_store_skus,
        gram: this.listVariants[index].gram,
      };

      for (const i of this.listVariants[index].options) {
        var x = {
          name: i.name,
          value: i.value,
        };
        temp.options.push(x);
      }

      this.listVariants.push(temp);
    },

    removeVariants(index) {
      this.listVariants.splice(index, 1);
      if (this.listVariants.length < 1) {
        this.showAddOptionBtn = true;
      }
    },

    async saveData() {
      var data = {
        product_type: this.productTypeName.toString(),
        upload_photo_description: this.upload_photo_description,
        choose_options_description: this.choose_options_description,
        crawl_description: this.crawl_description,
        option_names: this.headers,
        variants: this.listVariants,
      };
      var k = JSON.stringify(data);
      console.log(k);
      var currentSession = await this.$root.$refs.App.currentSession(
        "product-type-add-saveData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await fetch(window.domain + "product-types", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: k,
        })
          .then((response) => JSON.stringify(response))
          .then((data) => {
            console.log("product-type-add: ", data);
          })
          .catch((error) => {
            console.log("error ", error);
            this.error = error;
          });

        this.$router.push("/product-type");
      } else {
        console.log(
          "currentSession product-type-add-saveData-undefined: ",
          currentSession
        );
      }
    },

    validation() {
      if (this.productTypeName != "") {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },
  async mounted() {
    this.roles = await this.$cookies.get("product_type");
    if (this.roles.update_product_type) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }
  },
};
</script>

<style scoped>
</style>